module.exports = __webpack_public_path__ + "static/img/16.2ed6f2a2.png";